
/*
Generic factory class that can be injected into an angular router using
    @factory 'whateverFactoryName', ->
        return new Factory('app::Angular/Path/To/Models')
 */

(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.Factory = (function() {
    function Factory(model_path) {
      this.model_path = model_path;
      this._getClass = bind(this._getClass, this);
      this.make = bind(this.make, this);
      this.cache = {};
    }

    Factory.prototype.make = function(type, props, strict_props) {
      var cls, k, obj, v;
      if (props == null) {
        props = {};
      }
      if (strict_props == null) {
        strict_props = true;
      }
      cls = this._getClass(type);
      if (typeof cls !== 'function') {
        throw new Error("'" + type + "' isn't a constructor (looking in " + this.model_path + ")");
      }
      if (props instanceof cls) {
        obj = props;
      } else {
        obj = new cls();
        if (obj._require_predefined_props !== false) {
          for (k in props) {
            v = props[k];
            if (obj.hasOwnProperty(k) && typeof obj[k] !== 'function') {
              obj[k] = v;
            }
          }
        } else {
          for (k in props) {
            v = props[k];
            obj[k] = v;
          }
        }
      }
      return obj;
    };

    Factory.prototype._getClass = function(type) {
      var cls;
      if (this.cache[type] != null) {
        return this.cache[type];
      }
      cls = App.loadClass(this.model_path + "/" + type);
      this.cache[type] = cls;
      return cls;
    };

    return Factory;

  })();

}).call(this);
